// Centrale dayjs-setup: plugins en locales worden hier geregistreerd zodat elke component die
// via deze module importeert ze zeker beschikbaar heeft, ongeacht de laadvolgorde van chunks.
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/nl-be';
import 'dayjs/locale/fr';
import 'dayjs/locale/pl';
import 'dayjs/locale/ro';
import 'dayjs/locale/en';

dayjs.extend(relativeTime);

dayjs.extend(customParseFormat, {
  // oplossing om jaar <= '86 uit RRNR correct te parsen, zie https://github.com/iamkun/dayjs/issues/1418
  parseTwoDigitYear: (yearString) => +yearString + (+yearString > +dayjs().format('YY') ? 1900 : 2000),
});

export default dayjs;
